module.exports = __webpack_public_path__ + "static/img/2s-info-b1.10a0090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-info-b1.jpg
// module id = 3hqC
// module chunks = 0